import React, { useEffect, useRef, useState } from 'react';
import { OverflowWrapper } from 'app/components';
import { CloudArrowUp, Image, CheckCircle, File, Trash } from '@phosphor-icons/react';
import Button from '../button/button';

const FileComponent = ({ file, onDelete, className }) => {
  const fileName = file && file.name ?
    file.name
    : 'Uploaded Image';
  return (
    <div
      className={`flex items-center justify-between gap-4 border border-grey-30 rounded-lg ${className}`}
    >
      <div className="flex gap-3 items-center">
        <div className="bg-grey-10 items-center rounded-full p-2">
          <File size={16} />{' '}
        </div>
        <OverflowWrapper>{fileName}</OverflowWrapper>
        <Trash
          size={16}
          onClick={() => onDelete()}
          className="cursor-pointer"
        />
      </div>
      <CheckCircle
        size={24}
        color={'#009D64'}
        weight={'fill'}
      />
    </div>
  );
};

const FileDrop = (props) => {
  const {
    buttonText,
    allowedFileTypes,
    onUpload,
    uploadedFile,
  } = props;

  const [uploadError, setUploadError] = useState('');
  const [file, setFile] = useState(uploadedFile);
  const inputRef = useRef(null);

  useEffect(() => {
    setFile(uploadedFile);
  }, [uploadedFile]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (
      file) {
      setFile(file);
      setUploadError('');
      onUpload(file);
    } else {
      setFile(null);
      setUploadError('Please upload a valid file');
      onUpload(null);
    }
  };

  return (
    file ? (
      <div className="flex flex-col items-start gap-3">
        <div className="text-14">Uploaded Event Image</div>
        <FileComponent
          onDelete={() => setFile(null)}
          className="p-5"
          file={file}
        />
      </div>
    ) : (
      <div className="file-drop-card p-8 flex flex-col items-center justify-center w-fit rounded-xl bg-white">
        <Image size={32}
          color="#101010"
          weight="bold" />
        <div className="label label-14 text-black mt-5">Drag and drop or</div>
        <Button
          type="tertiary"
          className="mt-4"
          iconLeft={<CloudArrowUp />}
          onClick={() => inputRef.current.click()}
        >
          {buttonText}
        </Button>
        <input type="file"
          onChange={handleFileChange}
          hidden
          ref={inputRef}
          accept={allowedFileTypes}
        />
        {uploadError && (
          <div className="text-red-400 label-14 mt-4">{uploadError} </div>
        )}
      </div>
    )
  );
};

export default FileDrop;
